import { useReduxState } from 'hooks';
import { FormGroup } from 'components/common/form';
import { RadioGroupInput } from 'components/common/form/common';

interface Props {
  isFutureAchievement: boolean;
  onSelection: React.Dispatch<React.SetStateAction<boolean>>;
}

const AchievementsIndividualUpcomingOrNot = ({
  isFutureAchievement,
  onSelection
}: Props) => {
  const {
    language,
    messages,
    serverConfig: { individualAchievementsUpcomingOptions }
  } = useReduxState();

  return (
    <FormGroup
      label={
        individualAchievementsUpcomingOptions?.questionTranslations?.[
          language
        ] ||
        individualAchievementsUpcomingOptions?.question ||
        messages.achievementsIndividualCreateChoice
      }
    >
      <RadioGroupInput
        onChange={(value: string) => onSelection(value === 'true')}
        options={[
          {
            id: 'past-individual-achievement',
            label:
              individualAchievementsUpcomingOptions
                ?.optionCompletedTranslations?.[language] ||
              individualAchievementsUpcomingOptions?.optionCompleted ||
              messages.achievementsIndividualCreatePast,
            value: false
          },
          {
            id: 'upcoming-individual-achievement',
            label:
              individualAchievementsUpcomingOptions
                ?.optionUpcomingTranslations?.[language] ||
              individualAchievementsUpcomingOptions?.optionUpcoming ||
              messages.achievementsIndividualCreateUpcoming,
            value: true
          }
        ]}
        value={isFutureAchievement}
      />
    </FormGroup>
  );
};

export default AchievementsIndividualUpcomingOrNot;
